import React from "react";
import PurchaseConfirmationContainer from "../containers/PurchaseConfirmation";
import MainLayout from "../layouts/MainLayout";

const PurchaseConfirmation = () => {
  return (
    <MainLayout>
      <PurchaseConfirmationContainer />
    </MainLayout>
  );
};

export default PurchaseConfirmation;
